module.exports = __webpack_public_path__ + "assets/934f92dbbfe17fd4f1e404d8681b8f37.png";